import React, { createContext, useState } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userId, setUserId] = useState(localStorage.getItem('userId') || null);
  const [userName, setUserName] = useState(localStorage.getItem('userName') || null);
  const [userEmail, setUserEmail] = useState(localStorage.getItem('userEmail') || null);
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || null); // ⭐ Added role

  const login = (id, name, email, role) => {
    setUserId(id);
    setUserName(name);
    setUserEmail(email);
    setUserRole(role); // ⭐ set role

    localStorage.setItem('userId', id);
    localStorage.setItem('userName', name);
    localStorage.setItem('userEmail', email);
    localStorage.setItem('userRole', role); // ⭐ store role
  };

  const logout = () => {
    setUserId(null);
    setUserName(null);
    setUserEmail(null);
    setUserRole(null);

    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userRole'); // ⭐ clear role

    window.location.href = '/'; 
  };

  return (
    <AuthContext.Provider
      value={{ userId, userName, userEmail, userRole, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
